import styled, { css } from 'styled-components';

export const Td = styled.td<{
  clip?: boolean;
  center?: boolean;
  right?: boolean;
  top?: boolean;
  clickable?: boolean;
}>`
  ${({ clip }) =>
    clip &&
    css`
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    `}

  ${({ center }) =>
    center &&
    css`
      text-align: center;
    `}

    ${({ right }) =>
    right &&
    css`
        text-align: right;
      `}

    ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
    `}

    ${({ top }) =>
    top &&
    css`
      vertical-align: top;
    `}    

    &.removed {
    text-decoration: line-through;
  }

  &.disabled {
    pointer-events: none;
    cursor: default;
  }
`;
